import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusClient = () => {
  return (
    <SettingsMetaData propertyName={"Status_Client"} viewPropertyName={"Status"} />
  );
};
export default StatusClient;